module.exports = __webpack_public_path__ + "static/media/NTGS_Stream_page.f72c5f65.png";